/***************************************************************************/
"use client";
/***************************************************************************/

import * as ToastPrimitives from "@radix-ui/react-toast";
import { type VariantProps } from "class-variance-authority";
import { XIcon } from "lucide-react";
import * as React from "react";
import { cn } from "../../../utils/css";
import { ButtonIcon, buttonVariants } from "../button";

const ToastClose = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Close>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Close> &
    VariantProps<typeof buttonVariants>
>(({ className, variant, size, ...props }, ref) => (
  <ToastPrimitives.Close
    ref={ref}
    className={cn(
      buttonVariants({ variant: variant ?? "ghost", size: size ?? "sm" }),
      "transition-opacity group-hover:opacity-100",
      className,
    )}
    toast-close=""
    {...props}
  >
    <ButtonIcon size={size}>
      <XIcon />
    </ButtonIcon>
  </ToastPrimitives.Close>
));
ToastClose.displayName = ToastPrimitives.Close.displayName;

export { ToastClose };
